
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anime-generator",
      function () {
        return require("private-next-pages/anime-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anime-generator"])
      });
    }
  